import { getError } from '@/utils/helpers'
import AmenagementService from '@/services/AmenagementService'
import { AmenagementInterface, StateAmenagements } from '@/types/Amenagement'

export const namespaced = true

function setAmenagements(commit: Function, response: any) {
    commit('SET_AMENAGEMENTS', response.data.data)
    commit('SET_META', response.data.meta)
    commit('SET_LINKS', response.data.links)
    commit('SET_TOTALROWS', response.data.data.length)
    commit('SET_LAST_PAGE', response.data.meta ? response.data.meta.last_page : 1)
    commit('SET_CURRENT_PAGE', response.data.meta ? response.data.meta.current_page : 1)
    commit('SET_LOADING', false)
}

export const state: StateAmenagements = {
    amenagements: [],
    meta: null,
    links: null,
    loading: false,
    error: null,
    totalRows: 0,
    currentPage: 1,
    lastPage: 0,
    totalPage: 0,
    amenagementSelect: {},
    import_done: ''
}

export const mutations = {
    RESET_STATE(state: StateAmenagements) {
        Object.assign(state, {
            amenagements: [],
            meta: null,
            links: null,
            loading: false,
            error: null,
            totalRows: 0,
            currentPage: 1,
            lastPage: 0,
            totalPage: 0,
            amenagementSelect: {}
        })
    },
    SET_AMENAGEMENTS(state: any, amenagements: Array<AmenagementInterface>) {
        for (const amenagement of amenagements) {
            amenagement.amenagement_id = amenagement.id
        }
        state.amenagements = amenagements
    },
    SET_AMENAGEMENT(state: any, amenagement: AmenagementInterface) {
        amenagement.amenagement_id = amenagement.id
        const indexAmenagement = state.amenagements.findIndex((a: any) => a.id === amenagement.id)
        if (indexAmenagement === -1) {
            state.amenagements.push(amenagement)
        } else {
            state.amenagements[indexAmenagement] = amenagement
        }
    },
    SET_MORE_AMENAGEMENTS(state: any, amenagements: Array<AmenagementInterface>) {
        for (const amenagement of amenagements) {
            amenagement.amenagement_id = amenagement.id
        }
        state.amenagements = state.amenagements.concat(amenagements)
    },
    SET_META(state: any, meta: Array<any>) {
        state.meta = meta
    },
    SET_LINKS(state: any, links: Array<any>) {
        state.links = links
    },
    SET_LOADING(state: any, loading: boolean) {
        state.loading = loading
    },
    SET_ERROR(state: any, error: Array<any>) {
        state.error = error
    },
    SET_TOTALROWS(state: any, totalRows: number) {
        state.totalRows = totalRows
    },
    SET_LAST_PAGE(state: any, lastPage: number) {
        state.lastPage = lastPage
    },
    SET_TOTAL_PAGE(state: any, totalPage: number) {
        state.totalPage = totalPage
    },
    SET_CURRENT_PAGE(state: any, currentPage: number) {
        state.currentPage = currentPage
    },
    SET_AMENAGEMENT_SELECT(state: any, amenagement: AmenagementInterface) {
        amenagement.amenagement_id = amenagement.id
        state.amenagementSelect = amenagement
    },
    SET_IMPORT_DONE(state: any, etat: string) {
        state.import_done = etat
    }
}

export const actions = {
    getAmenagements({ commit }: { commit: any }, params?: any) {
        commit('SET_LOADING', true)
        return new Promise((resolve, reject) => {
            AmenagementService.getAmenagements(params)
                .then((response) => {
                    setAmenagements(commit, response)
                    resolve(response)
                })
                .catch((error) => {
                    commit('SET_LOADING', false)
                    commit('SET_ERROR', getError(error))
                    reject(error)
                })
        })
    },
    getMoreAmenagements({ commit }: { commit: any }, params: any) {
        commit('SET_LOADING', true)
        return new Promise((resolve, reject) => {
            AmenagementService.getAmenagements(params)
                .then((response) => {
                    commit('SET_MORE_AMENAGEMENTS', response.data.data)
                    commit('SET_CURRENT_PAGE', response.data.meta ? response.data.meta.current_page : 1)
                    commit('SET_LAST_PAGE', response.data.meta ? response.data.meta.last_page : 1)
                    commit('SET_TOTALROWS', state.totalRows + response.data.data.length)
                    resolve(response)
                })
                .catch((error) => {
                    commit('SET_ERROR', getError(error))
                    reject(error)
                })
                .finally(() => {
                    commit('SET_LOADING', false)
                })
        })
    },
    getAmenagement({ commit }: { commit: any }, params: any) {
        commit('SET_LOADING', true)
        return new Promise((resolve, reject) => {
            AmenagementService.getAmenagement(params.amenagement_id)
                .then((response) => {
                    commit('SET_AMENAGEMENT_SELECT', response.data.data)
                    commit('SET_AMENAGEMENT', response.data.data)
                    resolve(response)
                    commit('SET_LOADING', false)
                })
                .catch((error) => {
                    commit('SET_LOADING', false)
                    commit('SET_ERROR', getError(error))
                    reject(error)
                })
        })
    },
    updateAmenagement({ commit }: { commit: any }, params: any) {
        commit('SET_LOADING', true)
        return new Promise((resolve, reject) => {
            AmenagementService.updateAmenagement(params)
                .then((response) => {
                    commit('SET_LOADING', false)
                    resolve(response)
                })
                .catch((error) => {
                    commit('SET_LOADING', false)
                    commit('SET_ERROR', getError(error))
                    reject(error)
                })
        })
    },
    addAmenagement({ commit }: { commit: any }, params: any) {
        commit('SET_LOADING', true)
        return new Promise((resolve, reject) => {
            AmenagementService.addAmenagement(params)
                .then((response) => {
                    commit('SET_LOADING', false)
                    resolve(response)
                })
                .catch((error) => {
                    commit('SET_LOADING', false)
                    commit('SET_ERROR', getError(error))
                    reject(error)
                })
        })
    },
    deleteAmenagement({ commit }: { commit: any }, amenagement_id: number) {
        commit('SET_LOADING', true)
        return new Promise((resolve, reject) => {
            AmenagementService.deleteAmenagement(amenagement_id)
                .then((response) => {
                    commit('SET_LOADING', false)
                    resolve(response)
                })
                .catch((error) => {
                    commit('SET_LOADING', false)
                    commit('SET_ERROR', getError(error))
                    reject(error)
                })
        })
    },
    importAmenagements({ commit }: { commit: any }, payload: any) {
        commit('SET_LOADING', true)
        return new Promise((resolve, reject) => {
            AmenagementService.importAmenagements(payload)
                .then((response) => {
                    commit('SET_LOADING', false)
                    commit('SET_IMPORT_DONE', 'DONE')
                    resolve(response)
                })
                .catch((error) => {
                    commit('SET_LOADING', false)
                    commit('SET_ERROR', getError(error))
                    commit('SET_IMPORT_DONE', 'ERROR')
                    reject(error)
                })
        })
    },
    exportAmenagements({ commit }: { commit: any }) {
        commit('SET_LOADING', true)
        return new Promise((resolve, reject) => {
            AmenagementService.exportAmenagements()
                .then((response) => {
                    commit('SET_LOADING', false)
                    resolve(response)
                })
                .catch((error) => {
                    commit('SET_LOADING', false)
                    commit('SET_ERROR', getError(error))
                    reject(error)
                })
        })
    }
}

export const getters = {
    amenagements: (state: any) => {
        return state.amenagements
    },
    meta: (state: any) => {
        return state.meta
    },
    links: (state: any) => {
        return state.links
    },
    loading: (state: any) => {
        return state.loading
    },
    error: (state: any) => {
        return state.error
    },
    totalRows: (state: any) => {
        return state.amenagements.length
    },
    amenagementSelect: (state: any) => {
        return state.amenagementSelect
    },
    lastPage: (state: any) => {
        return state.lastPage
    },
    currentPage: (state: any) => {
        return state.currentPage
    },
    totalPage: (state: any) => {
        return state.totalPage
    }
}
